module.exports = __webpack_public_path__ + "static/img/l_10.47e84ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/l_10.png
// module id = d0zF
// module chunks = 1